(function(){
const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
const esc=s=>String(s??"").replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const FR=window.UE_FRAME||{}, LE=window.UE_LENS||{}, WA=window.UE_WA||"";
const fsw=n=>FR[String(n||"").toLowerCase().trim()]||"#cccccc";
const lsw=n=>LE[String(n||"").toLowerCase().trim()]||"#d9d9d9";
const money=c=>"Rs "+Math.round(c/100).toLocaleString("en-PK");

/* overlays */
function closeAll(){$$(".drawer-nav,.cart,.search-o").forEach(e=>e.classList.remove("open"))}
document.addEventListener("click",e=>{
  const o=e.target.closest("[data-open]"); if(o){e.preventDefault();const t=document.getElementById(o.dataset.open);t.classList.add("open");const i=t.querySelector("input:not([type=hidden])");if(i)setTimeout(()=>i.focus(),30);}
  if(e.target.closest("[data-close]")) closeAll();
});
document.addEventListener("keydown",e=>{if(e.key==="Escape")closeAll()});

/* slider */
const track=$("#slides");
if(track){let i=0;const n=track.children.length;
  const go=k=>{i=(k+n)%n;track.style.transform=`translateX(-${i*100}%)`;$$("[data-slide]").forEach((b,j)=>b.setAttribute("aria-current",j===i))};
  let t;const restart=()=>{clearInterval(t);if(!matchMedia("(prefers-reduced-motion: reduce)").matches)t=setInterval(()=>go(i+1),6000)};
  $$("[data-slide]").forEach(b=>b.onclick=()=>{go(+b.dataset.slide);restart()});restart();}

/* cards */
function paintCards(root){
  (root||document).querySelectorAll(".card .sw[data-frame]").forEach(b=>b.style.background=fsw(b.dataset.frame));
  (root||document).querySelectorAll(".card .tints i").forEach(i=>i.style.background=lsw(i.dataset.lens));
}
paintCards();
document.addEventListener("click",e=>{
  const s=e.target.closest(".card .sw"); if(!s) return;
  const c=s.closest(".card"), m=c.querySelector("img.main");
  if(m&&s.dataset.img){m.src=s.dataset.img;m.removeAttribute("srcset");}
  c.querySelectorAll("a.ph,.meta a").forEach(a=>a.href=s.dataset.url);
  c.querySelectorAll(".sw").forEach(b=>b.setAttribute("aria-pressed",b===s));
});

/* collection filters */
const grid=$("#grid");
if(grid&&$("#tb")){
  const cards=[...grid.children], st={type:"",g:"",shape:"",sort:"featured"};
  const draw=()=>{
    let list=cards.filter(c=>(!st.type||c.dataset.type===st.type)&&(!st.g||c.dataset.g===st.g)&&(!st.shape||c.dataset.shape===st.shape));
    if(st.sort==="low")list.sort((a,b)=>a.dataset.price-b.dataset.price);
    if(st.sort==="high")list.sort((a,b)=>b.dataset.price-a.dataset.price);
    if(st.sort==="az")list.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title));
    cards.forEach(c=>c.classList.add("hidden"));list.forEach(c=>{c.classList.remove("hidden");grid.appendChild(c)});
    $("#rn").textContent=list.length+(list.length===1?" frame":" frames");
    $("#empty").classList.toggle("hidden",list.length>0);
    $$("#tb .chip").forEach(c=>c.setAttribute("aria-pressed",st[c.dataset.k]===c.dataset.v));
  };
  $$("#tb .chip").forEach(c=>c.onclick=()=>{st[c.dataset.k]=st[c.dataset.k]===c.dataset.v?"":c.dataset.v;draw()});
  $("#sort").onchange=e=>{st.sort=e.target.value;draw()};
  $("#clear").onclick=()=>{st.type=st.g=st.shape="";draw()};
  draw();
}

/* product page */
const pd=$("#pdata");
if(pd){
  const P=JSON.parse(pd.textContent), V=P.variants, sun=V.some(v=>v.l);
  let cur=V.find(v=>v.id===P.current)||V[0];
  const frames=[...new Set(V.map(v=>v.f))];
  const re1=/^Redefine your success with Urban Eyes latest design\.\s*(.+?)\s+embeds a new sleek design, made from ([^,]+), with (.+?) frame & (.+?) lense color;(.*)$/i;
  const re2=/^Redefine your success with Urban Eyes latest design\.\s*(.+?)\s+embeds a new sleek design, made from ([^,]+), with (.+?) color;(.*)$/i;
  const describe=()=>{let m=P.desc.match(re1);if(m)return `Redefine your success with Urban Eyes latest design. ${m[1]} embeds a new sleek design, made from ${m[2]}, with ${cur.f} frame & ${cur.l||m[4]} lense color;${m[5]}`;
    m=P.desc.match(re2);if(m)return `Redefine your success with Urban Eyes latest design. ${m[1]} embeds a new sleek design, made from ${m[2]}, with ${cur.f} color${cur.l?` & ${cur.l} lenses`:""};${m[4]}`;return P.desc};
  const gallery=()=>{const key=P.title+" | "+cur.f+(cur.l?" | "+cur.l:"");
    let g=P.media.filter(m=>m.alt===key); if(!g.length)g=P.media.filter(m=>(m.alt||"").startsWith(P.title+" | "+cur.f)); if(!g.length)g=P.media;
    if(cur.img&&!g.some(m=>m.src===cur.img))g=[{src:cur.img,th:cur.img}].concat(g); return g;};
  const render=()=>{
    const g=gallery(); $("#gmain").src=g[0]?g[0].src:cur.img;
    $("#thumbs").innerHTML=g.map((m,i)=>`<button aria-label="View image ${i+1}" aria-current="${i===0}" data-s="${esc(m.src)}"><img src="${esc(m.th||m.src)}" alt=""></button>`).join("");
    $$("#thumbs button").forEach(b=>b.onclick=()=>{$("#gmain").src=b.dataset.s;$$("#thumbs button").forEach(x=>x.setAttribute("aria-current",x===b))});
    $("#frameName").textContent=cur.f;
    $("#frames").innerHTML=frames.map(f=>`<button class="sw lg" style="background:${fsw(f)}" aria-label="${esc(f)}" aria-pressed="${f===cur.f}" data-f="${esc(f)}"></button>`).join("");
    $$("#frames .sw").forEach(b=>b.onclick=()=>{const f=b.dataset.f;cur=V.find(v=>v.f===f&&v.l===cur.l)||V.find(v=>v.f===f);render()});
    const L=V.filter(v=>v.f===cur.f&&v.l);
    if(sun&&L.length){
      $("#lensName").textContent=cur.l; $("#lensCount").textContent=L.length>1?`(${L.length} options for this frame)`:"";
      $("#lenses").innerHTML=L.map(v=>`<button class="lens${L.length>1?"":" static"}" aria-pressed="${v.id===cur.id}" data-id="${v.id}"><i style="background:${lsw(v.l)}"></i>${esc(v.l)}</button>`).join("");
      $$("#lenses .lens").forEach(b=>b.onclick=()=>{cur=V.find(v=>v.id===+b.dataset.id);render()});
    } else {
      $("#lensName").textContent=P.clear; $("#lensCount").textContent="";
      $("#lenses").innerHTML=`<span class="lens static"><i style="background:${lsw(P.clear)}"></i>${esc(P.clear)}</span>`;
    }
    if($("#specLens")&&cur.l)$("#specLens").textContent=cur.l;
    $("#price").textContent=cur.price; $("#desc").textContent=describe();
    $("#addBtn").disabled=!cur.ok; $("#addBtn").textContent=cur.ok?"Add to bag":"Sold out";
    $("#waBtn").href=`https://wa.me/${WA}?text=`+encodeURIComponent(`Hi Urban Eye, I’d like to order ${P.title} (${cur.f}${cur.l?", "+cur.l+" lens":""}), ${cur.price}. ${location.origin}${location.pathname}?variant=${cur.id}`);
    const u=new URL(location.href);u.searchParams.set("variant",cur.id);history.replaceState(null,"",u);
  };
  render();
  $("#addBtn").onclick=async()=>{const b=$("#addBtn");b.disabled=true;
    try{const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:[{id:cur.id,quantity:1}]})});
      if(!r.ok)throw 0; toast(P.title+" added to your bag"); await openCart();}
    catch(e){toast("Sorry, that didn’t work. Please try again.")} b.disabled=false;};
}

/* cart drawer */
async function getCart(){const r=await fetch("/cart.js",{headers:{Accept:"application/json"}});return r.json()}
function setCount(n){const c=$("#cartCount");if(c){c.textContent=n;c.classList.toggle("hidden",!n)}}
async function renderCart(){
  const c=await getCart(); setCount(c.item_count);
  const items=$("#cartItems"), foot=$("#cartFoot"); if(!items) return c;
  if(!c.item_count){items.innerHTML=`<div class="emptycart"><p>Your bag is empty.</p><a class="btn ghost" href="/collections/all">Shop frames</a></div>`;foot.innerHTML="";return c;}
  items.innerHTML=c.items.map((it,i)=>`<div class="line"><img src="${esc(it.image||"")}" alt="">
    <div><div class="t"><a href="${esc(it.url)}" style="text-decoration:none">${esc(it.product_title)}</a><span>${money(it.final_line_price)}</span></div>
    <div class="c">${esc(it.product_type)}${it.variant_title?", "+esc(it.variant_title.replace(" / ",", ")):""}</div>
    <div style="display:flex;align-items:center"><div class="qty"><button data-line="${i+1}" data-q="${it.quantity-1}" aria-label="Remove one">−</button><span>${it.quantity}</span><button data-line="${i+1}" data-q="${it.quantity+1}" aria-label="Add one">+</button></div><button class="rm" data-line="${i+1}" data-q="0">Remove</button></div></div></div>`).join("");
  const msg="Hi Urban Eye, I’d like to place an order:\n"+c.items.map(it=>`• ${it.product_title}${it.variant_title?" ("+it.variant_title.replace(" / ",", ")+")":""} x${it.quantity}: ${money(it.final_line_price)}`).join("\n")+`\nTotal: ${money(c.total_price)}`;
  foot.innerHTML=`<div class="tot"><span>Subtotal</span><span>${money(c.total_price)}</span></div>
    <div class="note">Free delivery across Pakistan. Cash on delivery available at checkout.</div>
    <a class="btn" href="/checkout">Checkout</a>
    <a class="btn ghost" target="_blank" rel="noopener" href="https://wa.me/${WA}?text=${encodeURIComponent(msg)}">Or order on WhatsApp</a>`;
  return c;
}
async function openCart(){await renderCart();$("#cartDrawer").classList.add("open")}
document.addEventListener("click",async e=>{
  const q=e.target.closest("#cartItems [data-line]"); if(!q) return;
  await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({line:+q.dataset.line,quantity:+q.dataset.q})});
  renderCart();
});
const cb=$("#cartBtn"); if(cb&&!document.body.classList.contains("on-cart"))cb.addEventListener("click",e=>{e.preventDefault();openCart()});

function toast(m){const t=$("#toast");if(!t)return;t.textContent=m;t.classList.add("show");clearTimeout(toast.t);toast.t=setTimeout(()=>t.classList.remove("show"),2200)}
})();

/* ===== Repo-style header, announcement, product cards, wishlist ===== */
(function(){
const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];
const esc=s=>String(s??"").replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const FR=window.UE_FRAME||{}, LE=window.UE_LENS||{};
const fsw=n=>FR[String(n||"").toLowerCase().trim()]||"#d9d9d9";
const lsw=n=>LE[String(n||"").toLowerCase().trim()]||"#d9d9d9";
const store={get(k,d){try{return JSON.parse(localStorage.getItem(k))??d}catch(e){return d}},set(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}};

/* header shadow */
const H=$("#ueHeader");
if(H){const f=()=>H.classList.toggle("scrolled",scrollY>8);addEventListener("scroll",f,{passive:true});f();}

/* mega menus */
let mt;
const closeMega=()=>{$$(".mega").forEach(m=>m.classList.remove("open"));$$("[data-mega]").forEach(d=>{d.classList.remove("open");d.querySelector("button").setAttribute("aria-expanded","false")})};
const openMega=k=>{clearTimeout(mt);closeMega();const p=$(`.mega[data-panel="${k}"]`),d=$(`[data-mega="${k}"]`);if(p){p.classList.add("open");d.classList.add("open");d.querySelector("button").setAttribute("aria-expanded","true")}};
$$("[data-mega]").forEach(d=>{const k=d.dataset.mega;
  d.addEventListener("mouseenter",()=>openMega(k)); d.addEventListener("mouseleave",()=>{mt=setTimeout(closeMega,130)});
  d.querySelector("button").addEventListener("click",()=>d.classList.contains("open")?closeMega():openMega(k));});
$$(".mega").forEach(m=>{m.addEventListener("mouseenter",()=>clearTimeout(mt));m.addEventListener("mouseleave",()=>{mt=setTimeout(closeMega,130)})});
document.addEventListener("keydown",e=>{if(e.key==="Escape"){closeMega();$("#ueSearch")?.classList.remove("open");$("#ueMob")?.classList.remove("open")}});

/* mobile menu */
$("#ueBurger")?.addEventListener("click",()=>$("#ueMob").classList.toggle("open"));

/* search with live suggestions */
const sb=$("#ueSearchBtn"), sp=$("#ueSearch"), q=$("#ueQ"), res=$("#ueRes");
if(sb){sb.addEventListener("click",()=>{sp.classList.toggle("open");if(sp.classList.contains("open"))setTimeout(()=>q.focus(),30)});
  let st;
  q.addEventListener("input",()=>{clearTimeout(st);const t=q.value.trim();if(!t){res.innerHTML="";return}
    st=setTimeout(async()=>{try{
      const r=await fetch(`/search/suggest.json?q=${encodeURIComponent(t)}&resources[type]=product&resources[limit]=6`);
      const d=await r.json();const ps=(d.resources&&d.resources.results&&d.resources.results.products)||[];
      res.innerHTML=ps.length?ps.map(p=>`<a class="row" href="${esc(p.url)}"><span class="th">${p.image?`<img src="${esc(p.image)}" alt="">`:""}</span><span><b>${esc(p.title)}</b><small>${esc(p.type||"")}</small></span><span class="pr">PKR ${Number(p.price).toLocaleString("en-PK",{maximumFractionDigits:0})}</span></a>`).join("")+`<a class="all" href="/search?type=product&q=${encodeURIComponent(t)}">SEE ALL RESULTS FOR “${esc(t.toUpperCase())}” →</a>`
        :`<div style="padding:16px 14px;font:12px var(--mono);color:#7a8a95">No frames found for “${esc(t)}”. <a href="/collections/all" style="color:#0c2c41;font-weight:700">Browse all →</a></div>`;
    }catch(e){}},180);});}

/* announcement */
const ANN=["FREE SHIPPING ACROSS PAKISTAN ON ALL ORDERS","NEW SPRING 2026 COLLECTION — SHOP NOW"];
const ann=$("#ueAnn");
if(ann){ if(sessionStorage.getItem("ueAnnX")) ann.remove(); else { let i=0; setInterval(()=>{i=(i+1)%ANN.length;$("#ueAnnTxt").textContent=ANN[i]},4000);
  $("#ueAnnX").onclick=()=>{ann.remove();try{sessionStorage.setItem("ueAnnX","1")}catch(e){}}; } }

/* wishlist */
const getWish=()=>store.get("ue_wishlist",[]);
const paintHearts=()=>{const w=getWish();$$("[data-wish]").forEach(b=>{const on=w.includes(b.dataset.wish);b.classList.toggle("on",on);b.setAttribute("aria-pressed",on)})};

/* product cards */
const LENS_MS=900;
function initCard(c){
  if(c.dataset.ready) return; c.dataset.ready="1";
  let V=[]; try{V=JSON.parse(c.querySelector(".pcd").textContent)}catch(e){return}
  const frames=[...new Set(V.map(v=>v.f))];
  const box=c.querySelector(".img"), rail=c.querySelector(".rail"), cap=c.querySelector(".cap"), sws=c.querySelector(".sws"), add=c.querySelector(".add");
  let frame=frames[0], idx=0, timer=null, imgs=[];
  const lenses=()=>V.filter(v=>v.f===frame);
  const build=()=>{
    const L=lenses();
    box.querySelectorAll("img").forEach(i=>i.remove());
    imgs=L.map((v,i)=>{const im=new Image();im.decoding="async";im.alt=i===0?`${c.dataset.title} - ${frame}${v.l?", "+v.l+" lens":""}`:"";if(i===0){im.src=v.img;im.loading="lazy"}else{im.dataset.src=v.img}im.style.opacity=i===0?1:0;box.insertBefore(im,rail);return im});
    rail.innerHTML=L.length>1&&L[0].l?L.map((v,i)=>`<i title="${esc(v.l)}" style="background:${lsw(v.l)}" class="${i===0?"on":""}"></i>`).join(""):"";
    cap.style.display=L.length>1&&L[0].l?"":"none";
    idx=0; show();
    sws.innerHTML=frames.map(f=>`<button type="button" title="${esc(f)}" aria-label="${esc(f)}" style="background:${fsw(f)}" class="${f===frame?"on":""}" data-f="${esc(f)}"></button>`).join("");
  };
  const show=()=>{const L=lenses();imgs.forEach((im,i)=>{if(i===idx&&im.dataset.src){im.src=im.dataset.src;delete im.dataset.src}im.style.opacity=i===idx?1:0});
    rail.querySelectorAll("i").forEach((d,i)=>d.classList.toggle("on",i===idx));
    const v=L[idx]; if(v&&v.l){cap.querySelector("i").style.background=lsw(v.l);cap.querySelector("span").textContent=v.l+" lens"}};
  const start=()=>{c.classList.add("hov");imgs.forEach(im=>{if(im.dataset.src){im.src=im.dataset.src;delete im.dataset.src}});
    if(lenses().length>1&&!timer)timer=setInterval(()=>{idx=(idx+1)%lenses().length;show()},LENS_MS)};
  const stop=()=>{c.classList.remove("hov");clearInterval(timer);timer=null;idx=0;show()};
  c.addEventListener("mouseenter",start); c.addEventListener("mouseleave",stop);
  c.addEventListener("focus",e=>{if(e.target===c&&c.matches(":focus-visible"))start()}); c.addEventListener("blur",e=>{if(e.target===c)stop()});
  sws.addEventListener("click",e=>{const b=e.target.closest("button");if(!b)return;e.preventDefault();e.stopPropagation();frame=b.dataset.f;const h=c.classList.contains("hov");clearInterval(timer);timer=null;build();if(h)start();
    c.href=c.href.split("?")[0]+"?variant="+lenses()[0].id;});
  add.addEventListener("click",async e=>{e.preventDefault();e.stopPropagation();
    const v=lenses()[idx]||lenses()[0]; add.disabled=true;
    try{const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items:[{id:v.id,quantity:1}]})});
      if(!r.ok)throw 0; add.textContent="✓ ADDED TO BAG"; add.classList.add("done");
      const cr=await fetch("/cart.js").then(r=>r.json()); const cc=$("#cartCount"); if(cc){cc.textContent=cr.item_count;cc.classList.toggle("hidden",!cr.item_count)}
      setTimeout(()=>{add.textContent="ADD TO BAG";add.classList.remove("done")},1800);
    }catch(err){add.textContent="TRY AGAIN";setTimeout(()=>add.textContent="ADD TO BAG",1800)} add.disabled=false;});
  c.querySelector(".heart").addEventListener("click",e=>{e.preventDefault();e.stopPropagation();const h=c.dataset.handle;let w=getWish();w=w.includes(h)?w.filter(x=>x!==h):[...w,h];store.set("ue_wishlist",w);paintHearts();
    if(document.body.dataset.page==="wishlist"&&!w.includes(h)){c.remove();wishEmpty()}});
  build();
}
window.ueInitCards=root=>{(root||document).querySelectorAll(".pc").forEach(initCard);paintHearts()};
window.ueInitCards();

/* wishlist page */
const wl=$("#ueWishGrid");
function wishEmpty(){const e=$("#ueWishEmpty");if(e&&wl)e.classList.toggle("hidden",wl.children.length>0)}
if(wl){document.body.dataset.page="wishlist";(async()=>{const w=getWish();
  const html=await Promise.all(w.map(h=>fetch(`/products/${encodeURIComponent(h)}?view=card`).then(r=>r.ok?r.text():"").catch(()=>"")));
  wl.innerHTML=html.join(""); window.ueInitCards(wl); $("#ueWishCount").textContent=wl.children.length; wishEmpty();})();}
})();
